export type PresetRubro = "general" | "carniceria" | "panaderia";
export type ModoCargaLocal = "unidad" | "peso";

export interface PerfilRubroLocal {
  etiqueta: string;
  preset: PresetRubro;
  modoInicial: ModoCargaLocal;
}

const normalizar = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const rubrosPorPeso: Record<string, string> = {
  carniceria: "Carnicería",
  verduleria: "Verdulería",
  fiambreria: "Fiambrería",
  pescaderia: "Pescadería",
};

export const resolverPerfilRubroLocal = (rubro?: string): PerfilRubroLocal | undefined => {
  const etiqueta = rubro?.trim() ?? "";
  if (!etiqueta || normalizar(etiqueta) === "general") return undefined;

  const rubroNormalizado = normalizar(etiqueta);
  const etiquetaPeso = rubrosPorPeso[rubroNormalizado];
  if (etiquetaPeso) {
    return { etiqueta: etiquetaPeso, preset: "carniceria", modoInicial: "peso" };
  }

  if (rubroNormalizado === "panaderia") {
    return { etiqueta: "Panadería", preset: "panaderia", modoInicial: "unidad" };
  }

  return { etiqueta, preset: "general", modoInicial: "unidad" };
};

export const resolverDecimalesCantidad = (
  decimalesConfigurados: number | undefined,
  preset: PresetRubro,
  modoCarga: ModoCargaLocal
) => {
  const decimales = Math.min(Math.max(Number(decimalesConfigurados ?? 2), 0), 6);
  const minimoPerfil = preset === "carniceria" || modoCarga === "peso"
    ? 2
    : preset === "panaderia"
      ? 1
      : 0;

  return Math.max(decimales, minimoPerfil);
};
